import { defineStore } from "pinia";
import { ref } from "vue";
import type { IPresentation } from "./IPresentation";

export const useAuthentication = defineStore( 'authentication', () => 
{

    const KEY = 'auth';
    const isAuthenticated = ref( false );

    const authenticate = ( presentation: IPresentation, password?: string ) => 
    {
        isAuthenticated.value = ( password ?? '' ).toLowerCase() == presentation.password.toLowerCase();
        if( isAuthenticated.value )
        {
            setAuthToken( presentation.key, new Date() );
            return;
        }
        localStorage.removeItem( KEY );
    }

    function check( key: string )
    {
       
        const token = getAuthToken( key );
        if( token == null )
        {
            isAuthenticated.value = false;
            return false;
        }

        const date = new Date( token.date );
        isAuthenticated.value = date.getTime() >= new Date().getTime() - ( 1 * 24 * 60 * 60 * 1000 );
        return isAuthenticated.value;

    }

    function getAuthToken( key: string )
    {
        try
        {
            const tokens = JSON.parse( localStorage.getItem( KEY ) ?? "[]" ) as { presentation: string, date: string }[];
            const match = tokens.find( a => a.presentation == key );
            return match
        }
        catch
        {
            return null;
        }
    }

    function setAuthToken( key: string, date: Date )
    {

        let tokens = [] as { presentation: string, date: string }[];
        try
        {
            tokens = JSON.parse( localStorage.getItem( KEY ) ?? "[]" ) as { presentation: string, date: string }[];
        }
        catch {}

        const token = { presentation: key, date: date.toJSON().slice( 0, 10 ) }
        const filteredTokens = tokens.filter( t => t.presentation != key );
        filteredTokens.push( token );
        localStorage.setItem( KEY, JSON.stringify( filteredTokens ) );

    }

    return {
        isAuthenticated,
        authenticate,
        check
    }
});